import React from 'react';
import cn from '../../utils/cn';

export type LegacyButtonProps = React.ComponentPropsWithoutRef<'button'>;

/**
 * @deprecated This component was migrated from Preact and should not be used or refactored.
 * It does not comply with our current architectural patterns (compound components, proper separation of concerns, etc.).
 * These legacy components will be migrated in due course.
 */
export function LegacyButton({ children, className, ...props }: LegacyButtonProps) {
  return (
    <button
      className={cn(
        'rounded-md bg-[#59585d] px-[30px] py-[10px] text-white duration-500 hover:bg-brand-500',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
